"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExposeService = void 0;
var inversify_1 = require("inversify");
var uuid_1 = require("uuid");
var event_tracking_core_1 = require("@al/event-tracking-core");
var utils_1 = require("../utils");
var types_1 = require("../types");
var notifyEvents_1 = require("../constants/notifyEvents");
var processor_1 = require("../utils/processor");
var ExposeService = /** @class */ (function () {
    function ExposeService() {
        var _this = this;
        this.getObserveItems = function () {
            var items = Array.from(document.querySelectorAll("[data-al-et-expose]"));
            _this.exposeDataManager.resetObserveItem();
            items.forEach(function (item, index) {
                _this.exposeDataManager.addObserveItem({
                    target: item,
                    absolutePosition: index + 1,
                });
            });
            return items;
        };
        this.exposeAfterReCollectConfig = null;
    }
    ExposeService.prototype.collectData = function (element) {
        return (0, processor_1.processDataset)((0, utils_1.collectDataFromDataset)(element, event_tracking_core_1.EXPOSE_DATASET_KEY, false));
    };
    ExposeService.prototype.generateExposedItem = function (exposing, needPvid) {
        var data = this.collectData(exposing.target);
        var item = __assign(__assign({ target: exposing.target, exposeCount: exposing.exposeCount, duration: Date.now() - exposing.startTimestamp, 
            // 占位
            pvid: needPvid ? (0, uuid_1.v4)() : "", elementExtraInfo: (data === null || data === void 0 ? void 0 : data.ext) || (data === null || data === void 0 ? void 0 : data.elementExtraInfo) || {} }, data), { absolutePosition: exposing.absolutePosition });
        return item;
    };
    ExposeService.prototype.handleIntersectingItems = function (item) {
        var entry = item.entry;
        var items = this.exposeDataManager.getExposedItems();
        var last = items[items.length - 1];
        var lastAp = ((last && last.absolutePosition) || items.length) + 1;
        var observeItem = this.exposeDataManager.findObserveItem(entry.target);
        this.exposeDataManager.addExposingItem({
            id: (0, uuid_1.v4)(),
            startTimestamp: item.startTimestamp,
            exposeCount: 1,
            target: entry.target,
            duration: 0,
            // 正常情况下不可能使用到 lastAp 的值
            absolutePosition: (observeItem === null || observeItem === void 0 ? void 0 : observeItem.absolutePosition) || lastAp,
        });
    };
    ExposeService.prototype.handleIntersectedItems = function (item) {
        var now = Date.now();
        var exposingIndex = this.exposeDataManager.findExposingItemIndex(item.entry.target);
        // 小于 1 秒曝光时间为无效曝光，不处理
        if (now - item.startTimestamp < 1000) {
            this.exposeDataManager.removeExposingItem(exposingIndex);
            return;
        }
        if (exposingIndex > -1) {
            var exposingItem = this.exposeDataManager.getExposingItems()[exposingIndex];
            var exposed = this.generateExposedItem(exposingItem);
            this.exposeDataManager.addExposedItem(exposed);
            this.exposeDataManager.addCurrentExpose(exposed);
            // 元素已曝光，从 exposingItems 中移除
            this.exposeDataManager.removeExposingItem(exposingIndex);
        }
        this.exposed();
    };
    ExposeService.prototype.handleExposeClick = function (data) {
        var element = data.element;
        if (!element) {
            this.exposeDataManager.setClickedExposed(undefined);
            return;
        }
        // 点击时触发整屏曝光，pvid 需保持一致，因此将 pvid 传给 exposed 函数
        var finalPvid;
        var clickExposedItem = this.exposeDataManager.findExposedItem(element);
        // 点击了已曝光元素，存起来，click 事件处理需要拿到这个值，取 pvid, absolutePosition
        if (clickExposedItem) {
            finalPvid = clickExposedItem.pvid;
            this.exposeDataManager.setClickedExposed(clickExposedItem);
        }
        var exposing = this.exposeDataManager.findExposingItem(element);
        // 还没在曝光区内，生成一个正在曝光的元素加入队列
        if (!exposing) {
            var currentObserveItem = this.exposeDataManager.findObserveItem(element);
            if (currentObserveItem) {
                var nowExposing = {
                    id: (0, uuid_1.v4)(),
                    startTimestamp: Date.now(),
                    exposeCount: 1,
                    target: currentObserveItem.target,
                    duration: 0,
                    absolutePosition: currentObserveItem.absolutePosition,
                };
                this.exposeDataManager.addExposingItem(nowExposing);
                exposing = nowExposing;
            }
        }
        if (exposing) {
            // 点击的直接生成 pvid
            var exposed = this.generateExposedItem(exposing, true);
            finalPvid = exposed.pvid;
            this.exposeDataManager.setClickedExposed(exposed);
        }
        else {
            this.exposeDataManager.setClickedExposed(undefined);
        }
        this.exposeImmediately({
            finalPvid: finalPvid,
            needPvid: true,
            force: true,
        });
        return exposing;
    };
    ExposeService.prototype.isNeedPositionalInfo = function (data) {
        return !!data.needPosInfo;
    };
    ExposeService.prototype.addPositionalInfo = function (data, needPvid) {
        var pvid = data.pvid, absolutePosition = data.absolutePosition, elementInfo = data.elementInfo, ei = data.ei, rest = __rest(data, ["pvid", "absolutePosition", "elementInfo", "ei"]);
        // 同时将 ei 和 elementInfo 组合到了一个字段
        var result = __assign(__assign({}, rest), { absolutePosition: absolutePosition, elementInfo: __assign({ absolutePosition: absolutePosition }, (elementInfo || ei)) });
        if (needPvid) {
            result.pvid = pvid;
            if (result.elementInfo) {
                result.elementInfo.pvid = pvid;
            }
        }
        return result;
    };
    ExposeService.prototype.mayAddPositionalInfo = function (data, needPvid) {
        var result = data;
        if (this.isNeedPositionalInfo(data)) {
            result = this.addPositionalInfo(data, needPvid);
        }
        return result;
    };
    ExposeService.prototype.generatePositionalInfo = function () {
        return {
            pvid: (0, uuid_1.v4)(),
            absolutePosition: this.exposeDataManager.getExposedItems().length + 1,
        };
    };
    ExposeService.prototype.mayAddPosInfoToManualListInfoItem = function (listItem, posInfo) {
        var ei = listItem.ei || listItem.elementInfo;
        if (listItem.needPosInfo) {
            return __assign(__assign({}, listItem), { elementInfo: __assign(__assign(__assign({}, posInfo), ei), { absolutePosition: (ei === null || ei === void 0 ? void 0 : ei.ap) || (ei === null || ei === void 0 ? void 0 : ei.absolutePosition) || posInfo.absolutePosition }) });
        }
        return listItem;
    };
    ExposeService.prototype.convertListInfoItemToExposed = function (listItem) {
        var ei = listItem.ei || listItem.elementInfo;
        var pvid = listItem.pvid || (ei === null || ei === void 0 ? void 0 : ei.pvid);
        var absolutePosition = listItem.rp || (ei === null || ei === void 0 ? void 0 : ei.ap) || (ei === null || ei === void 0 ? void 0 : ei.absolutePosition);
        return {
            pvid: pvid,
            absolutePosition: absolutePosition,
            target: listItem.target,
            exposeCount: listItem.cnt || listItem.exposeCount,
            duration: listItem.duration || listItem.du,
            needPosInfo: listItem.needPosInfo,
            elementExtraInfo: listItem.ext || listItem.ext,
            elementInfo: listItem.ei || listItem.elementInfo,
        };
    };
    ExposeService.prototype.cleanBeforeSave = function (data) {
        var target = data.target, pvid = data.pvid, absolutePosition = data.absolutePosition, needPosInfo = data.needPosInfo, rest = __rest(data, ["target", "pvid", "absolutePosition", "needPosInfo"]);
        return rest;
    };
    ExposeService.prototype.dispatchData = function (data, needPvid) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                            var result, i, j;
                            var _this = this;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        result = data.map(function (item) {
                                            var r = _this.mayAddPositionalInfo(item, needPvid);
                                            return r;
                                        });
                                        for (i = 0; i < result.length - 1; i++) {
                                            for (j = i + 1; j < result.length; j++) {
                                                if (result[j].target === result[i].target) {
                                                    result.splice(j, 1);
                                                }
                                            }
                                        }
                                        result = result.map(function (item) { return _this.cleanBeforeSave(item); });
                                        if (!result.length) {
                                            return [2 /*return*/];
                                        }
                                        return [4 /*yield*/, ((_a = this.dispatchLogService) === null || _a === void 0 ? void 0 : _a.dispatch({
                                                list: [
                                                    {
                                                        eventType: types_1.EventType.Expose,
                                                        offset: 0,
                                                        isComplete: true,
                                                        listInfo: result,
                                                    },
                                                ],
                                            }))];
                                    case 1:
                                        _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExposeService.prototype.exposed = function () {
        var _this = this;
        clearTimeout(this.notifyTimer);
        this.notifyTimer = setTimeout(function () {
            var currentExposes = _this.exposeDataManager.getCurrentExposes();
            if (!currentExposes.length) {
                return;
            }
            var pvid = (0, uuid_1.v4)();
            var newItems = currentExposes.map(function (item) { return (__assign(__assign({}, item), { pvid: item.pvid || pvid })); });
            _this.dispatchData(newItems);
            _this.exposeDataManager.updateExposedItems(newItems);
            _this.exposeDataManager.setCurrentExposes([]);
        }, 500);
    };
    ExposeService.prototype.destroy = function () {
        this.intersectionService.destroy();
        this.observableService.unsubscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECTING, this);
        this.observableService.unsubscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECTED, this);
        this.observableService.unsubscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECT_CALLBACK_END, this);
    };
    ExposeService.prototype.getIntersectionInitConfig = function () {
        var rootMargin = this.configService.get().intersectionRootMargin;
        if (rootMargin) {
            return {
                intersectionOptions: { rootMargin: rootMargin, threshold: [0.5] },
            };
        }
    };
    ExposeService.prototype.enable = function () {
        this.destroy();
        this.intersectionService.init(this.getIntersectionInitConfig());
        this.observableService.subscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECTING, this);
        this.observableService.subscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECTED, this);
        this.observableService.subscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECT_CALLBACK_END, this);
        this.intersectionService.monitor(this.getObserveItems);
    };
    ExposeService.prototype.stop = function () {
        this.intersectionService.stop();
        this.observableService.unsubscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECTING, this);
        this.observableService.unsubscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECTED, this);
        this.observableService.unsubscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECT_CALLBACK_END, this);
    };
    ExposeService.prototype.reCollect = function () {
        // 未防止可视区范围出现异常，业务通知重新收集时，应该初始化 intersection
        // intersectionService 内部会判断是否可复用 IntersectionObserver
        this.intersectionService.init(this.getIntersectionInitConfig());
        this.intersectionService.monitor(this.getObserveItems);
    };
    ExposeService.prototype.processManualExpose = function (data) {
        var _this = this;
        var result = (data || []).map(function (item) {
            var usedKey = "li";
            if (item.li) {
                usedKey = "li";
            }
            else if (item.listInfo) {
                usedKey = "listInfo";
            }
            var posInfo = _this.generatePositionalInfo();
            item[usedKey] = (item[usedKey] || []).map(function (listItem, index) {
                var _a, _b;
                // posInfo 放到 elementInfo 中
                var transformedItem = _this.mayAddPosInfoToManualListInfoItem(listItem, posInfo);
                // 再将这三个值放在顶层，与 IExposedItem 结构类似，不会存到 localstorage
                transformedItem.absolutePosition =
                    ((_a = transformedItem.elementInfo) === null || _a === void 0 ? void 0 : _a.absolutePosition) || posInfo.absolutePosition;
                transformedItem.pvid = ((_b = transformedItem.elementInfo) === null || _b === void 0 ? void 0 : _b.pvid) || posInfo.pvid;
                var exposedItem = _this.convertListInfoItemToExposed(transformedItem);
                _this.exposeDataManager.addExposedItem(exposedItem);
                // 去掉手动曝光可能传进来的 target，为 html 元素
                return _this.cleanBeforeSave(transformedItem);
            });
            return item;
        });
        return result;
    };
    ExposeService.prototype.exposeImmediately = function (options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var finalPvid, needPvid, _a, force, pvid, exposingItems, items;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        finalPvid = options.finalPvid, needPvid = options.needPvid, _a = options.force, force = _a === void 0 ? false : _a;
                        pvid = finalPvid || (0, uuid_1.v4)();
                        exposingItems = this.exposeDataManager.getExposingItems();
                        if (!force) {
                            exposingItems = exposingItems.filter(function (item) {
                                return Date.now() - item.startTimestamp >= 1000;
                            });
                        }
                        items = exposingItems.map(function (item) {
                            var exposed = _this.generateExposedItem(item);
                            return __assign(__assign({}, exposed), { pvid: pvid });
                        });
                        return [4 /*yield*/, this.dispatchData(items, needPvid)];
                    case 1:
                        _b.sent();
                        this.exposeDataManager.resetExposingItems();
                        this.exposeDataManager.resetExposedItems();
                        this.exposeDataManager.setCurrentExposes([]);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 重新收集后手动曝光可视区内
     */
    ExposeService.prototype.exposeAfterReCollect = function (config) {
        if (config === void 0) { config = { force: true }; }
        this.exposeAfterReCollectConfig = config;
    };
    ExposeService.prototype.setLogService = function (service) {
        this.dispatchLogService = service;
    };
    ExposeService.prototype.update = function (item, eventType) {
        if (eventType === notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECTING) {
            this.handleIntersectingItems(item);
        }
        else if (eventType === notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECTED) {
            this.handleIntersectedItems(item);
        }
        else if (eventType === notifyEvents_1.coreNotifyEvents.NOTIFY_ENTRY_INTERSECT_CALLBACK_END) {
            if (this.exposeAfterReCollectConfig) {
                this.exposeImmediately({ force: this.exposeAfterReCollectConfig.force });
                this.exposeAfterReCollectConfig = null;
            }
        }
        else if (eventType === notifyEvents_1.NOTIFY_EXPOSE_CLICK) {
            this.handleExposeClick(item);
        }
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IApplicationExecutor),
        __metadata("design:type", Object)
    ], ExposeService.prototype, "applicationExecutor", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IObservableService),
        __metadata("design:type", Object)
    ], ExposeService.prototype, "observableService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IIntersectionService),
        __metadata("design:type", Object)
    ], ExposeService.prototype, "intersectionService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IExposeDataManager),
        __metadata("design:type", Object)
    ], ExposeService.prototype, "exposeDataManager", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IConfigService),
        (0, inversify_1.named)(types_1.TAG.SDKConfigService),
        __metadata("design:type", Object)
    ], ExposeService.prototype, "configService", void 0);
    ExposeService = __decorate([
        (0, inversify_1.injectable)()
    ], ExposeService);
    return ExposeService;
}());
exports.ExposeService = ExposeService;
